import { render, staticRenderFns } from "./nav-menu.vue?vue&type=template&id=34bc0fa4&scoped=true&"
import script from "./nav-menu.vue?vue&type=script&lang=js&"
export * from "./nav-menu.vue?vue&type=script&lang=js&"
import style0 from "./nav-menu.vue?vue&type=style&index=0&id=34bc0fa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bc0fa4",
  null
  
)

export default component.exports